module.exports = __webpack_public_path__ + "static/media/dots.768d93be.png";